import { FAILURE_REASON, PAYMENT_SESSION_STATUS } from '../../constants';
import { RedcatPaymentsApiResponse } from './types';

export const isPaymentSessionResolved = (
  status: PAYMENT_SESSION_STATUS | null,
): boolean =>
  status !== null && status !== PAYMENT_SESSION_STATUS.PAYMENT_PENDING;

export const emitEftposStatus = (
  hook: any,
  statusMsg: string,
  txnStarted: boolean,
) => {
  // Hook may not be registered in some environments/tests.
  if (!hook) {
    return;
  }

  hook({ statusMsg, txnStarted });
};

export const buildApprovedSubPayment = (
  selectedPayment: SubPayment,
  response: RedcatPaymentsApiResponse,
) => ({
  // Normalize provider response fields into currentOrder subPayment fields.
  ...selectedPayment,
  cardType: response.card_type,
  referenceNumber: response.transaction_id,
});

type Options = {
  readonly onPaymentFailed?: () => void;
};
export const getRedcatPaymentFailureReason = async (
  error: unknown,
  options: Options = {},
): Promise<FAILURE_REASON | undefined> => {
  const errorResponse = (error as any)?.details?.response;
  let errorJson: any;

  // For non-2xx responses, RedcatApiHandler throws before parsing JSON.
  // Parse it here when available so we can distinguish declined vs cancelled.
  if (errorResponse && typeof errorResponse.clone === 'function') {
    try {
      errorJson = await errorResponse.clone().json();
    } catch (_) {
      // ignore parse errors
    }
  } else if (errorResponse && typeof errorResponse.json === 'function') {
    try {
      errorJson = await errorResponse.json();
    } catch (_) {
      // ignore parse errors
    }
  }

  const errorMessageFromBody = `${errorJson?.message || ''}`.toUpperCase();
  const statusCode = (error as any)?.details?.statusCode;
  const errorType = (error as any)?.details?.type;

  if (statusCode === 402) {
    options.onPaymentFailed?.();
    if (['CANCELLED', 'CANCELED'].includes(errorMessageFromBody)) {
      return FAILURE_REASON.PAYMENT_CANCELLED;
    }

    if (errorMessageFromBody === 'DECLINED') {
      return FAILURE_REASON.PAYMENT_DECLINED;
    }
  } else if (statusCode === 504) {
    return FAILURE_REASON.PAYMENT_TIME_OUT;
  } else if (errorType === 'connectivity') {
    return FAILURE_REASON.FETCH_FAILED;
  }

  return undefined;
};
